import { useEffect } from "react"
import { rootStore } from "stores/root-store"
import { ContentWrapper, MainComponent } from "components/common-styles"
import FreightEnquiryForm from "components/freight-enquiry/freight-enquiry-form"
import { useNavigate } from "react-router-dom"

const FreightEnquiry = () => {
  const navigate = useNavigate()

  useEffect(() => {
    rootStore.setScreenTitle("Freight Enquiry")
    return () => rootStore.setScreenTitle("")
  }, [])

  const handleClose = () => {
    navigate(-1)
  }

  const handleSave = () => {
    rootStore.setScreenTitle("Freight Enquiry")
    navigate(-1)
  }

  return (
    <MainComponent>
      <ContentWrapper>
        <FreightEnquiryForm onClose={handleClose} onSave={handleSave} />
      </ContentWrapper>
    </MainComponent>
  )
}

export default FreightEnquiry
